var f = require('./formatters');
var PolynomialType = require('./type');

/**
 * PolynomialTypeInt is a prootype that represents int type
 * It matches:
 * int
 * int[]
 * int[4]
 * int[][]
 * int[3][]
 * int[][6][], ...
 * int32
 * int64[]
 * int8[4]
 * int256[][]
 * int[3][]
 * int64[][6][], ...
 */
var PolynomialTypeInt = function () {
    this._inputFormatter = f.formatInputInt;
    this._outputFormatter = f.formatOutputInt;
};

PolynomialTypeInt.prototype = new PolynomialType({});
PolynomialTypeInt.prototype.constructor = PolynomialTypeInt;

PolynomialTypeInt.prototype.isType = function (name) {
    return !!name.match(/^int([0-9]*)?(\[([0-9]*)\])*$/);
};

module.exports = PolynomialTypeInt;
